import { LeafFlexContainer } from "./flex-container.component.js";
customElements.define("leaf-flex-container", LeafFlexContainer);
export {
  LeafFlexContainer
};
//# sourceMappingURL=flex-container.js.map
